import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    currentExpiresAt: String
  }
  static targets = ['modal']

  hide () {
    const bodyId = document.body.id
    const redirectIds = new Set([
      'cart-index',
      'purchases-data',
      'purchases-data-processing',
      'events-event-session',
      'purchases-payment'
    ])

    if (redirectIds.has(bodyId)) {
      window.location.href = 'https://ticketline.pt'
    }

    sessionStorage.setItem('last_cart_expiration_shown', this.currentExpiresAtValue)
    this.modalTarget.classList.add('none')
  }
}
